import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.modalEnabled)?_c(VBtn,{attrs:{"rounded":"","outlined":!_vm.mini,"small":"","icon":_vm.mini,"color":'info',"title":"Изменить адрес"},on:{"click":_vm.enableModal}},[_c(VIcon,[_vm._v(_vm._s('mdi-pencil'))]),(!_vm.mini)?_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s('Изменить адрес'))]):_vm._e()],1):_c('EditAddressForm',{attrs:{"model":_vm.model,"modal-enabled":_vm.modalEnabled},on:{"EditAddressFormClosed":_vm.disableModal,"EditAddressFormSuccess":_vm.onSuccess}})
}
var staticRenderFns = []

export { render, staticRenderFns }